import React from 'react';
import './ErrorList.scss';

type ErrorListProps = {
    errors?: null | string[];
};

export default class ErrorList extends React.Component<ErrorListProps> {
    render() {
        const { errors } = this.props;
        if (!errors || errors.length === 0) return null;
        return (
            <ul className="errorList" role="alert">
                {errors.map((m, i) => (
                    <li key={i}>{m}</li>
                ))}
            </ul>
        );
    }
}
